import React from "react";
import * as CONSTANTS from "../services/constants";

export default function DropMonthYear({ year, month, handleChangeDate }) {
  return (
    <div className="row text-center p-3">
      <span className="text-center mr-1">
        <b>
          Ano:<i className="text-danger">*</i>
        </b>
        <select
          className="form-control"
          id="year"
          required
          name="year"
          value={year}
          onChange={handleChangeDate}
        >
          <option />
          {CONSTANTS.years()
            ? CONSTANTS.years().map((item, key) => {
                return item ? (
                  <option key={key} value={item}>
                    {item}
                  </option>
                ) : null;
              })
            : null}
        </select>
      </span>

      <span className="text-center mr-1">
        <b>
          Mês:<i className="text-danger">*</i>
        </b>
        <select
          className="form-control"
          id="month"
          required
          name="month"
          value={month}
          onChange={handleChangeDate}
        >
          <option />
          {CONSTANTS.months()
            ? CONSTANTS.months().map((item, key) => {
                return item ? (
                  <option key={key} value={item}>
                    {item}
                  </option>
                ) : null;
              })
            : null}
        </select>
      </span>
      </div>
  );
}
